var map = {
	"./music-instructions.json": 4696,
	"./music-library-intro2024.json": 4697,
	"./music-library-launch2024.json": 4698,
	"./music-progression.json": 4699,
	"./startSourcesAdvanced.json": 4700,
	"./startSourcesSimple.json": 4701,
	"./startSourcesSimple2.json": 4702,
	"./startSourcesTracks.json": 4703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4465;